import { Badge } from '@/components/ui/badge';
import type { PurchaseOrderDto } from '../types/purchaseOrder.types';
import { DocumentStatusEnum } from '../types/purchaseOrder.types';

interface PoStatusBadgeProps {
  po: PurchaseOrderDto;
}

export function PoStatusBadge({ po }: PoStatusBadgeProps) {
  if (po.documentStatus === DocumentStatusEnum.Closed) {
    return <Badge variant="secondary">Closed</Badge>;
  }

  switch (po.netSuiteStatus) {
    case 'B':
      return <Badge variant="outline">Pending Receipt</Badge>;
    case 'D':
      return <Badge className="bg-info/10 text-info border-info/30">Partially Received</Badge>;
    case 'E':
      return <Badge className="bg-warning/10 text-warning border-warning/30">Pending Billing</Badge>;
    case 'F':
      return <Badge className="bg-warning/10 text-warning border-warning/30">Pending Bill</Badge>;
    case 'G':
      return <Badge variant="secondary">Fully Billed</Badge>;
    case 'H':
      return <Badge variant="secondary">Closed</Badge>;
    default:
      return <Badge variant="outline">{po.poStatus || 'Unknown'}</Badge>;
  }
}
